export default __webpack_public_path__ + "static/media/dealercards_reavel.c45d9c5f.mp3";